<template>
  <QRcode
      ref="QRcodeRef"
      v-bind:onError="error"
      v-bind:onSuccess="success"
      workerPath="/js/qrWork.js"
      v-bind:config="{tipText:'Align QR code within the frame to scan' }"
  />
</template>

<script>
  import QRcode from "../components/QRcode.vue";
  
  export default {
      name: "Scan",
      data() {
          return {
              isB: false,
              text: {}
          }
      },
      components: {QRcode},
      methods: {
          error: function (e) {
              this.$Notice.warning({
                  title: e.message,
              });
              if (this.isB) this.$router.go(-2);
              else this.$router.push({name: 'Home'});
              // this.getbinfo();
          },
          success: function (value) {
              this.$refs.QRcodeRef.close(); //关闭
              let code = value.substring(value.lastIndexOf('/') + 1);
              console.log(value)
              if (this.isB) {
                  this.getbinfo(code);
              } else {
                  this.$router.push({
                      name: 'Loading',
                      params: {code: code}
                  });
              }
          },
          getbinfo(code) {
              let _me = this;
              // alert(_me.id);
              let params = {
                  access_key: ACCESS_KEY,
                  device: _me.text.device,
                  info_code: K_A_PREV + _me.text.info_code,
                  activation_code: code,
                  type: K_TYPE
              };
              _me.common.httpPost('anti/fake/activate/b', params)
                  .then((res) => {
                      let msg = _me.common.language ? res.message.split('|')[0] : res.message.split('|')[1];
                      if (res.code == '100000') {
                          //B码未激活
                          if (res.data.email == '') {
                              this.$router.push({name: 'B_bind', params: {data: this.text, code: code}});
                          } else {
                              _me.$Modal.info({
                                  title: _me.$t('message.success'),
                                  content: _me.$t('message.success_content.activate'),
                              });
                          }
                      } else {
                          //B码不正确
                          this.$router.push({name: 'B_fake', params: {data: this.text}});
                      }
                  })
                  .catch(err => {
                      _me.$Modal.info({
                          title: _me.$t('message.error'),
                          content: err
                      });
                  });
          },
      },
      created() {
          this.isB = this.$route.params.data != undefined;
          this.text = this.isB ? this.$route.params.data : {};
      }
  }
</script>

<style scoped>

</style>
